
import { defineComponent } from 'vue';
import Button from '@/components/atoms/Button.vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'RegistrationPanel',
  components: {
    Button
  },
  emits: ['registration-request'],
  methods: {
    switchToRegistration () {
      this.$router.push({
        path: '/registration',
        query: {
          ...this.$route.query
        }
      });
    }
  },
  computed: {
    ...mapGetters([
      'registrationRequestPanelMessages',
      'registrationRequestPanelUtils'
    ])
  }
});
